import Vue from 'vue';
import { isHighDensity } from '~/utils/high-resolution';
import debounce from '~/utils/debounce';
import shuffleArray from '~/utils/shuffle-array';
import HeroSliderComponent from '../components/home/hero-slider-component';
import * as screenSizes from '../utils/screen-sizes';

DM.Module.HeroSlider = ((DM) => {

    const SELECTOR = '.js-slider-hero';

    class HeroSlider {

        constructor(container) {
            this.items = this.getData();
            this.vm = this.createComponent();
            this.vm.$mount(container);
        }

        getData() {
            const array = DM.Boot.MainPage.mainPageBanners;
            return [array.shift(), ...shuffleArray(array)];
        }

        createComponent() {
            return new Vue({
                components: {
                    'dm-hero-slider': HeroSliderComponent, 
                },
                data: {
                    items: this.items,
                    slots: 1,
                    preload: {
                        sequentially: true,
                    },
                },
                template: '<dm-hero-slider :slots="slots" :items="items" :preload="preload" />',
            });
        }
    }

    [].map.call(document.querySelectorAll(SELECTOR), (item) => {
        return new HeroSlider(item);
    });

})(window.DM);

